import { Switch, Route, useRouteMatch } from 'react-router-dom';
import LoadComponentWithRetry from '@/app/routes/LoadComponentWithRetry';
import { PageLoading } from '@/app/ui/page';

const ViewComponent = LoadComponentWithRetry(() => import('./ViewLoginPage'), <PageLoading variant="app" />);

const Routes = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={path} component={ViewComponent} />
    </Switch>
  );
};

export default Routes;
